import React from 'react';
import Header from './Header';
import Footer from './Footer';

const SkinAndHairSupplements = () => {
    const rawHtml = `
        <style>
            .form-control::placeholder {
                color: white !important;
                opacity: 0.7;
            }
            .form-control:-ms-input-placeholder {
                color: white !important;
                opacity: 0.7;
            }
            .form-control::-ms-input-placeholder {
                color: white !important;
                opacity: 0.7;
            }
            .accordion-item {
                border: 1px solid rgba(0,0,0,.125);
                margin-bottom: 1rem;
                border-radius: 0.5rem !important;
                overflow: hidden;
                box-shadow: 0 2px 4px rgba(0,0,0,.05);
                transition: all 0.3s ease;
            }
            .accordion-item:hover {
                box-shadow: 0 4px 8px rgba(0,0,0,.1);
                transform: translateY(-2px);
            }
            .accordion-button {
                padding: 1.25rem;
                font-weight: 600;
                font-size: 1.1rem;
                color: #333;
                background-color: #f8f9fa;
                border: none;
                position: relative;
            }
            .accordion-button:not(.collapsed) {
                color: #fff;
                background-color: var(--cnvs-themecolor, #2E3192);
                box-shadow: none;
            }
            .accordion-button:not(.collapsed)::after {
                filter: brightness(0) invert(1);
            }
            .accordion-button:focus {
                box-shadow: none;
                border-color: rgba(0,0,0,.125);
            }
            .accordion-body {
                padding: 1.5rem;
                background-color: #fff;
            }
            .table {
                margin-bottom: 0;
            }
            .table thead th {
                background-color: #f8f9fa;
                border-bottom: 2px solid #dee2e6;
                font-weight: 600;
                text-transform: uppercase;
                font-size: 0.85rem;
                letter-spacing: 0.5px;
            }
            .table tbody td {
                vertical-align: middle;
                font-size: 0.95rem;
            }
            .table tbody tr:hover {
                background-color: rgba(0,0,0,.02);
            }
            .table td, .table th {
                word-break: break-word;
                white-space: normal;
                vertical-align: top;
            }
            .table ul {
                padding-left: 1.2em;
                margin-bottom: 0;
            }
            .table li {
                word-break: break-word;
                white-space: normal;
            }
        </style>

        <div id="wrapper">
            <section id="slider" class="slider-element include-header" style="background: linear-gradient(90deg, rgba(34, 193, 195, 0.06), rgba(253, 187, 45, 0.1));">
                <div class="container mt-lg-6">
                    <div class="row justify-content-between align-items-center py-lg-6 py-5">
                        <div class="col-lg-5 mb-4 mb-lg-0">
                            <img src="demos/doctors/images/icons/wave.svg" alt="..." class="position-absolute top-0 start-0 translate-middle d-none d-md-block" width="50">
                            <h2 class="display-3 fw-bold color all-ts">Skin & Hair Supplements</h2>
                            <p>Explore our range of supplements for skin radiance and hair health</p>
                        </div>
                        <div class="col-lg-6">
                            <div class="row align-items-center g-4">
                                <div class="col-6">
                                    <img src="https://i.pinimg.com/736x/2a/0a/0c/2a0a0c1e9f2df4591d14645aa2b39a28.jpg" alt="Image" class="object-cover rounded-6">
                                </div>
                                <div class="col-6">
                                    <img src="demos/doctors/images/hero/r2.jpg" alt="Image" class="object-cover rounded-6 mb-4">
                                    <img src="demos/doctors/images/hero/r3.jpg" alt="Image" class="object-cover rounded-6">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="content">
                <div class="content-wrap py-0">
                    <div id="products" class="section bg-transparent">
                        <div class="container">
                            <div class="row justify-content-center mb-4">
                                <div class="col-md-9 text-center">
                                    <h2 class="display-4 mb-3">Skin & Hair Supplements</h2>
                                    <p>Comprehensive range of supplements for skin glow, anti-aging, and hair growth</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="accordion">
                                        <!-- SKIN AND HAIR SUPPLEMENTS -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#skinHairSupplements">
                                                    <i class="bi bi-capsule me-2"></i>SKIN & HAIR SUPPLEMENTS
                                                </button>
                                            </h2>
                                            <div id="skinHairSupplements" class="accordion-collapse collapse show">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>PRODUCT</th>
                                                                    <th>DESCRIPTION / KEY INGREDIENTS</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Glutathione + Vitamin C + Grape Seed Extract Tablets</td>
                                                                    <td>Antioxidant blend for skin brightening and protection from oxidative stress.</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Biotin With Each L-Series Amino Acids Tablets</td>
                                                                    <td>Supports hair growth and strength with biotin and essential amino acids.</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Collagen Peptide Type I & II Tablets</td>
                                                                    <td>Promotes skin elasticity and joint health with dual collagen types.</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Astaxanthin Tablets</td>
                                                                    <td>Potent antioxidant for skin protection and anti-aging benefits.</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Marine Collagen Powder</td>
                                                                    <td>Supports skin hydration, firmness, and hair strength.</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Vegan Collagen Builder Powder</td>
                                                                    <td>Plant-based formula to boost natural collagen production for skin and hair.</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Hair Grow Protein Powder</td>
                                                                    <td>Protein-rich supplement for hair growth and scalp nourishment.</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    `;

    return (
        <>
            <Header />
            <div dangerouslySetInnerHTML={{ __html: rawHtml }} />
            <Footer />
        </>
    );
};

export default SkinAndHairSupplements; 